import { mapGetters, mapActions } from "vuex";
import { socket } from "../util/socketioService.js";

export default {
  computed: {
    ...mapGetters("userData", ["userId", "companyId"]),
  },
  methods: {
    attemptReconnection() {
      const reconnectionInterval = setInterval(() => {
        if (socket && !socket.connected) {
          socket.connect();
        } else {
          clearInterval(reconnectionInterval);
        }
      }, 3000);
    },
    ...mapActions("newsfeedManagement", ["addPost", "removePost"]),
    ...mapActions("userData", ["companyUsersTimestampReset"]),
    ...mapActions("trainingManagement", ["trainingTimestampReset"]),
    ...mapActions("rewardsManagement", ["rewardsTimestampReset"]),
    ...mapActions("contentManagement", ["topicsTimestampReset"]),
    ...mapActions("challengesManagement", ["challengesTimestampReset"]),
    ...mapActions("eventsManagement", ["eventsTimestampReset"]),
    ...mapActions("formsManagement", ["formsTimestampReset"]),
    ...mapActions("recruitmentManagement", ["jobsTimestampReset"]),
    ...mapActions("onboardingManagement", ["prospectsTimestampReset"]),
  },
  mounted() {
    socket.on("connect", () => {
      if (this.userId) {
        socket.emit("join", [this.userId, this.companyId]);
      }
    });

    socket.on("reconnect", () => {
      socket.emit("join", [this.userId, this.companyId]);
    });

    socket.on("disconnect", () => {
      this.attemptReconnection();
    });

    socket.on("connect_error", () => {
      this.attemptReconnection();
    });

    // Newsfeed
    socket.on("newsfeed-post", (data) => {
      this.addPost(data);
    });

    socket.on("remove-newsfeed-post", (data) => {
      this.removePost(data.postId);
    });

    // Reset Timestamps
    socket.on("company-users-modified", () => {
      this.companyUsersTimestampReset();
    });
    socket.on("training-modified", () => {
      this.trainingTimestampReset();
    });
    socket.on("challenges-modified", () => {
      this.challengesTimestampReset();
    });
    socket.on("rewards-modified", () => {
      this.rewardsTimestampReset();
    });
    socket.on("content-modified", () => {
      this.topicsTimestampReset();
    });
    socket.on("meetings-modified", () => {
      this.meetingsTimestampReset();
    });
    socket.on("events-modified", () => {
      this.eventsTimestampReset();
    });
    socket.on("forms-modified", () => {
      this.formsTimestampReset();
    });
    socket.on("recruitment-modified", () => {
      this.jobsTimestampReset();
    });
    socket.on("onboarding-modified", () => {
      this.prospectsTimestampReset();
    });
  },
};
